<template>
  <ExActionsPopUp
    :value="show"
    headline="Retire Department"
    :icon="'department_icon'"
    :htmlInfo="info"
    actionLabel="Retire"
    :termination="true"
    :centerHeadline="true"
    actionsTopSpacing="24px"
    @onAction="$emit('onRetire')"
    @input="$emit('onClose')"
    data-testid="retire-department-popup"
    :applyBorderClass="true"
    :backgroundPatternBottomRight="true"
    :width="500"
    :styleHeadlineMarginBottom="false"
  >
  </ExActionsPopUp>
</template>
<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    default: "",
  },
});

defineEmits(["onRetire", "onClose"]);

const formattedInfo = computed(() => {
  return `<div style="max-width: 454px; margin: 0 auto; text-align: center;">
    <div>You are about to retire Department <strong>${props.name}</strong>.</div>
    <div>Positions assigned to this department will be removed from it.</div>
  </div>`;
});

const info = computed(() => {
  return formattedInfo.value;
});
</script>
